import { z } from 'zod'

export const formSchema = z.object({
  date: z.string(),
  studentName: z.string(),
  oen: z.string(),
  year: z.string(),                  // "Year 1" | "Year 2" | ""
  daysAbsent: z.string(),
  totalDaysAbsent: z.string(),
  timesLate: z.string(),
  totalTimesLate: z.string(),
  frenchProgram: z.string(),         // "Immersion" | "Core" | "Extended" | ""
  teacher: z.string(),
  earlyChildhoodEducator: z.string(),
  principal: z.string(),
  telephone: z.string(),
  board: z.string(),
  school: z.string(),
  schoolAddress: z.string(),
  boardAddress: z.string(),
  placement: z.string(),             // "Kindergarten Year 2" | "Grade 1" | ""

  belongingEsl: z.string(),
  belongingIep: z.string(),
  belongingComments: z.string(),

  selfRegulationEsl: z.string(),
  selfRegulationIep: z.string(),
  selfRegulationComments: z.string(),

  literacyMathEsl: z.string(),
  literacyMathIep: z.string(),
  literacyMathComments: z.string(),

  problemSolvingEsl: z.string(),
  problemSolvingIep: z.string(),
  problemSolvingComments: z.string(),

  ersCompleted: z.string(),          // "yes" | "no" | "na" | ""
  ersDateYear: z.string(),
  ersDateMonth: z.string(),
  ersDateDay: z.string(),
  ersBenchmarkMet: z.string(),       // "yes" | "no" | ""

  eceNames: z.string(),

  _completedFields: z.array(z.string()).default([]),
})

export const defaultValues = {
  ...Object.fromEntries(
    Object.keys(formSchema.shape)
      .filter((k) => k !== '_completedFields')
      .map((k) => [k, ''])
  ),
  _completedFields: [],
}
